import React from "react"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import HousingRentersTable from "./HousingRentersTable"


export default function HousingRentersList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Housing Renters")} />
        <HousingRentersTable />
      </div>
    </div>
  )
}
